<script>
import lazyLoadComponent from '@router/lazyload-component'
import cloneDeep from 'lodash/cloneDeep'
import {
  genderFilter,
  bookingStatusFilter,
  orderPaymentMethodFilter,
  paymentStatusMapFilter,
  taxTypeMap,
  carrierTypeMap,
  orderPaymentMethodMap,
  orderStatusFilter,
  orderSourceFilter,
} from '@utils/filter-value-to-text'
import formatDate from '@utils/format-date'
import { calcTotal, calcBasePrice } from '@utils/order-form'
import { Clipboard } from '@capacitor/clipboard'
import { membreLevelValidityTime } from '@utils/memberLevel'
import DialogPaidConfirm from '@components/Dialog/DialogPaidConfirm'
import depositOrderMixin from '@/src/mixins/depositOrderMixin'
const initData = () => {
  return {
    params: [],
    fullName: '',
    gender: 'male',
    phoneCode: '+886',
    phoneNumber: '',
    phone: '',
    // bankType:'',
    email: '',
    note: '',
    status: 2,
    paymentStatus: 'UNPAID',
    basePrice: '',
    total: '',
    allowExpired: 0,
    coupon: undefined,
    couponCode: '',
    memberId: '',
    prepaidOrderUuid: '',
    byOrderExtrafields: {},
    customerInfos: [],
    // paymentMethod: 'Prepaid',
    paymentMethod: '',
    productId: '',
    bankType: '',
    address: '',
    petId: '',
    city: '',
    district: '',
    errorHandle: false,
    type: 'cosmetic',

    // 假資料先暫做
    storeCredit: '',
    credit: '',
  }
}

export default {
  components: {
    BaseCollapse: () => lazyLoadComponent(import('@components/BaseCollapse')),
    BaseStateLabel: () => lazyLoadComponent(import('@components/BaseStateLabel')),
    OrderChangeStatusDialog: () => lazyLoadComponent(import('@components/OrderChangeStatusDialog')),
    DepositOrderForm: () => lazyLoadComponent(import('./DepositOrderForm')),
    PrepaidOrderForm: () => lazyLoadComponent(import('@components/Orders/PrepaidOrderForm')),
    /* 重構元件 */
    TotalEdit: () => lazyLoadComponent(import('./components/TotalEdit')),
    MemberForm: () => lazyLoadComponent(import('./components/MemberForm')),
    MemberInfo: () => lazyLoadComponent(import('./components/MemberInfo')),
    RefundForm: () => lazyLoadComponent(import('./components/RefundForm')),
    PaymentEditForm: () => lazyLoadComponent(import('./components/PaymentEditForm')),
    TotalStatementDetail: () => lazyLoadComponent(import('./components/TotalStatementDetail')),
    TotalStatement: () => lazyLoadComponent(import('./components/TotalStatement')),
    DeductHistory: () => lazyLoadComponent(import('./components/DeductHistory')),
    OrderMemberInfo: () => lazyLoadComponent(import('./components/OrderMemberInfo')),
    PetList: () => lazyLoadComponent(import('./components/PetList')),
    SignatureDialog: () => lazyLoadComponent(import('@components/SignatureDialog')),
    ProfitSharing: () => lazyLoadComponent(import('./components/ProfitSharing')),
    PaymentFormDialog: () => lazyLoadComponent(import('./components/PaymentFormDialog')),
    DialogPaidConfirm,
  },
  filters: {
    orderPaymentMethodFilter,
    formatDate,
    bookingStatusFilter,
    paymentStatusMapFilter,
    genderFilter,
    orderStatusFilter,
    orderSourceFilter,
  },
  mixins: [depositOrderMixin],
  props: {
    defaultValue: {
      type: Object,
      default: () => initData(),
    },
  },
  data() {
    return {
      orderHeaderId: `orderHeader__${Math.floor(Math.random() * 10000)}`,
      orderPaymentMethodMap,
      taxTypeMap,
      carrierTypeMap,
      headerHeight: 0,
      submitData: cloneDeep(this.defaultValue),
      currentOrder: cloneDeep(this.defaultValue),
      // 各種 show

      // 全畫面
      totalAllShow: false,
      // 右邊的show，左邊有任何選擇，右邊的show要全部關掉
      memberInfoShow: false,
      editDetailEnabled: false,

      // 各種 loading
      tryingStore: false,
      tryingGetMember: false,

      paymentWay: 'offline',
      userSameAsMember: true,
      statusDialogVisible: false,

      basePrice: 0,
      orderRefundShow: false,
      tryingRefund: false,
      orderHistoryShow: false,
      editPaymentMethodShow: false,
      tryingSendSMS: false,
      deleteIds: [],
      shareLink: '',
      shareDialogVisible: false,
      payMethods: {
        Cash: '到店付款(現金)',
        StoreCredit: '現場刷卡',
        Atm: '線下匯款',
      },
      tryingStoreOrderItem: false,
      tryingPayOrder: false,
      visibleDeductHistory: false,

      componentKey: 0,
      createDepositOrderVisible: false,
      drawerPrepaidOrderFormVisible: false, // 滑進包月方案複製
      mapStatusName: {
        PAID: '訂單資訊',
        UNPAID: '付款',
      },
      appStyle: process.env.VUE_APP_BUILD_MODE === 'admin-app-build',
      isOrderNoteEdit: false,
      isExpiredDateEdit: false,

      // 會員資訊
      memberInfo: {
        tags: [],
        phoneCode: '',
        phoneNumber: '',
        level: {},
      },
      memberInfoActiveTab: 'information',
      // 寵物資訊
      petInfoActiveTab: 'information',
      petShow: false,
      // 是否顯示寵物列表
      isShowPetList: false,
      petList: [],

      // 付款確認Dialog
      isDialogPaidConfirmVisible: false,
      paidConfirmValue: {},

      // 分期付款彈窗
      installmentDialogVisible: false,
      installmentOrder: {},
      originalExpiredDate: '',
    }
  },
  computed: {
    getInstallmentUnpayCount() {
      let result = this.defaultValue.installments.filter((item) => {
        return item.paymentStatus !== 'PAID'
      }).length
      return result + '期'
    },
    getPaidAmount() {
      let result = 0
      let filterArr = this.defaultValue.installments.filter((item) => {
        return item.paymentStatus === 'PAID'
      })
      if (filterArr) {
        filterArr.forEach((item) => {
          result += item.amount
        })
      }
      return result
    },
    currentHistory() {
      return this.currentOrder.history
    },
    prepaidPlanItem() {
      return this.defaultValue.params.find((item) => {
        return item.type === 'prepaid-plan'
      })
    },
    depositReduce() {
      if (this.memberInfo.depositInfo === undefined) return 0

      const { bonus, point } = this.memberInfo.depositInfo.solution2.reduceDepositTotal
      return bonus + point
    },
    prepaidPlanTotal() {
      return this.prepaidPlanItem.total
    },
    submitPriceTotal() {
      let total = parseInt(this.prepaidPlanTotal)

      this.updateBasePrice()
      total = calcTotal({ price: total, totalEditList: this.currentOrder.params })

      return total
    },
    linkTitle() {
      const { childrenOrders } = this.defaultValue
      if (childrenOrders.length) {
        let hasUnpaid = false
        hasUnpaid = childrenOrders.some((order) => order.paymentStatus === 'UNPAID')
        return this.mapStatusName[hasUnpaid ? 'UNPAID' : 'PAID']
      } else return this.mapStatusName[this.defaultValue.paymentStatus]
    },
    /* 會員等級效期 */
    validityTime() {
      const startedAt = this.memberInfo.level.startedAt
      const expiredAt = this.memberInfo.level.expiredAt
      return membreLevelValidityTime(startedAt, expiredAt)
    },
    /************ 寵物資訊相關 start ************/
    personalityContentOrder() {
      return this.defaultValue.pet.questions.personality.join('，')
    },
    healthyContentOrder() {
      const content = this.defaultValue.pet.questions.healthy.map((item) => {
        return `${item.title}${item.text ? ' ( ' : ''} ${item.text ? item.text : ''}${item.text ? ' )' : ''}`
      })
      return content.join('，')
    },
    behaviorContentOrder() {
      const content = this.defaultValue.pet.questions.behavior.map((item) => {
        return `${item.title}${item.text ? ' ( ' : ''} ${item.text ? item.text : ''}${item.text ? ' )' : ''}`
      })
      return content
    },
    vaccineContentOrder() {
      let vaccine = ''
      switch (this.defaultValue.pet.questions.vaccine) {
        case 1:
          vaccine = '1 劑'
          break
        case 2:
          vaccine = '2 劑'
          break
        case 3:
          vaccine = '3 劑'
          break
        default:
          break
      }
      return vaccine
    },
    petSizeId() {
      return this.defaultValue.pet.sizeId
    },
    /************ 寵物資訊相關 end ************/

    /* 到期日更改 */
    proxyExpiredDate: {
      get() {
        return this.defaultValue.extendedExpiredDate || this.defaultValue.expiredDate
      },
      set(val) {
        // 1) 畫面立即更新 (.sync)
        this.$emit('update:defaultValue', {
          ...this.defaultValue,
          extendedExpiredDate: val,
        })

        // 2) 同步到 currentOrder（後續 tryToSaveOrder() 仍讀 currentOrder）
        // this.defaultValue.extendedExpiredDate = val
        this.currentOrder.extendedExpiredDate = val
      },
    },
  },
  created() {
    this.fetchExtraInfo()
    this.installmentOrder = this.defaultValue
  },
  mounted() {
    const updateHeaderHeight = () => {
      this.$nextTick(() => {
        const interval = setInterval(() => {
          if (document.querySelector(`#${this.orderHeaderId}`) !== null) {
            clearInterval(interval)
            this.headerHeight = document.querySelector(`#${this.orderHeaderId}`).offsetHeight + 40
          }
        }, 500)
      })
    }
    updateHeaderHeight()
    this.originalExpiredDate = this.defaultValue.expiredDate
  },
  methods: {
    openTotalEdit() {
      this.totalAllShow = true
    },
    cancelToTalEdit() {
      this.totalAllShow = false
    },
    async onCreateDepositOrderDone() {
      this.$refs.depositOrderForm.closeDrawer()
      await this.tryToFetchDetail(this.memberInfo.id)
    },
    fetchExtraInfo() {
      this.tryToFetchDetail(this.defaultValue.memberId)
    },
    closeAllInfo() {
      this.memberInfoShow = false
    },
    async tryToRefund(refundData) {
      if (refundData.paymentMethod !== 'Deposit') {
        // 輸入金額小於等於上限，且大於建議值表示會虧本
        if (refundData.amount <= this.currentOrder.backBalance && refundData.amount > this.currentOrder.recommendRefundValue.amount) {
          await this.$confirm('虧本', '提示', {
            confirmButtonText: '確定',
            type: 'warning',
            center: true,
          })
        } else if (refundData.amount > this.currentOrder.backBalance) {
          // 輸入金額大於上限
          this.$confirm('退款金額不能超過退款上限', '提示', {
            confirmButtonText: '確定',
            showCancelButton: false,
            type: 'warning',
            center: true,
          })
          return
        }
      } else {
        if (refundData.amount > this.currentOrder.recommendRefundValue.amount) {
          await this.$confirm('虧本', '提示', {
            confirmButtonText: '確定',
            type: 'warning',
            center: true,
          })
        }
      }
      try {
        this.tryingRefund = true
        await this.$store.dispatch('order/refundOrder', {
          id: this.currentOrder.id,
          refundData: refundData,
        })
        this.$confirm('退款已完成', '提示', {
          confirmButtonText: '關閉',
          showCancelButton: false,
          type: 'success',
          center: true,
        })
        this.updateOrder()
        this.orderRefundShow = false
        this.tryToFetchDetail(this.memberInfo.id)
      } catch (error) {
        console.error('TCL: refundOrder -> error', error)
      } finally {
        this.tryingRefund = false
      }
    },
    closeOpenRefund() {
      this.orderRefundShow = false
    },
    closeHistory() {
      this.orderHistoryShow = false
    },
    editOpenTotalEdit(index) {
      this.totalAllShow = true
      this.currentOrder = cloneDeep(this.defaultValue)
      this.deleteIds = []
    },
    editOpenPaymentMethod(index) {
      this.currentOrder = cloneDeep(this.defaultValue)
      // 取得 bankType
      delete this.currentOrder.bankType
      if (this.currentOrder.Vacc) {
        this.currentOrder = {
          ...this.currentOrder,
          bankType: this.currentOrder.Vacc.BankType,
        }
      }
      this.editPaymentMethodShow = true
    },
    editOpenHistory(index) {
      this.currentOrder = cloneDeep(this.defaultValue)
      this.orderHistoryShow = true
    },
    tryToCancelOrder(index) {
      this.currentOrder = cloneDeep(this.defaultValue)
      this.statusDialogVisible = true
    },
    editOpenRefund(index) {
      this.currentOrder = cloneDeep(this.defaultValue)
      this.refundSubmitData = {
        refundDate: formatDate(new Date(), 'date-dash'),
        amount: this.currentOrder.recommendRefundValue.amount,
        note: '',
        paymentMethod: '',
        bonus: this.currentOrder.recommendRefundValue.bonus,
      }
      this.orderRefundShow = true
    },
    /**
     * @description 顯示選擇發送方式
     */
    showShareDialog() {
      this.shareDialogVisible = true
    },
    async tryToGetShareLink() {
      this.shareLink = await this.$store.dispatch('order/getLink', this.defaultValue.id)
    },
    /**
     * @description 複製此包月方案 -> 點擊複製按鈕會滑進@components/orders/PrepaidOrderForm
     * prepaidGroupOrdering === 0 因為此包月被刪除,所以不能開啟
     */
    async copyThisPrepaidOrder() {
      if (this.defaultValue.prepaidGroupOrdering === 0) {
        this.$alert(`此${this.$t('prepaid.Base')}方案已被刪除`, '無法複製', {
          confirmButtonText: '確認',
          center: true,
        })
        return
      }
      this.drawerPrepaidOrderFormVisible = true
    },
    /**
     * @description [複製-購買包月方案]儲存後的function
     */
    handleUpdateOrders() {
      if (this.$refs.prepaidCopyDrawer) this.$refs.prepaidCopyDrawer.closeDrawer()
      this.$emit('update')
    },
    handleShareLink(platform) {
      const platformLinkMap = {
        facebook: `https://www.facebook.com/sharer/sharer.php?u=${this.shareLink}`,
        line: `https://social-plugins.line.me/lineit/share?url=${this.shareLink}`,
      }
      window.open(platformLinkMap[platform], '_blank')
    },
    async tryToSendSMS() {
      this.tryingSendSMS = true
      try {
        await this.$store.dispatch('prepaid/sendLink', {
          orderId: this.defaultValue.id,
          router: 'sms',
        })
        this.$alert(`已發送${this.linkTitle}連結簡訊至使用人電話`, '簡訊發送成功！', {
          confirmButtonText: '確認',
          center: true,
        })
      } finally {
        this.tryingSendSMS = false
      }
    },
    async copyShareLink() {
      const ghostInput = document.createElement('INPUT')
      document.body.appendChild(ghostInput)
      ghostInput.setAttribute('value', this.shareLink)
      ghostInput.select()
      document.execCommand('copy')
      document.body.removeChild(ghostInput)

      if (process.env.VUE_APP_BUILD_MODE === 'admin-app-build') {
        await Clipboard.write({
          string: this.shareLink,
        })
      }

      this.$message('連結複製成功')
    },
    /***** 付款確認  Start *****/
    paidConfirm() {
      const paymentMethod = this.paidConfirmValue.paymentMethod
      this.tryToPayOrder(paymentMethod, this.paidConfirmValue)
    },
    async openPaidDialog() {
      if (this.defaultValue.paymentMethod) {
        if (this.defaultValue.paymentMethod !== 'Installment') {
          this.isDialogPaidConfirmVisible = true
          this.paidConfirmValue = this.submitData
        } else {
          this.installmentOrder = await this.$store.dispatch('prepaid/fetchOrderSingle', this.defaultValue.id)
          this.installmentDialogVisible = true
        }
      } else {
        this.$message({
          type: 'error',
          message: '請選擇付款方式',
        })
        this.editOpenPaymentMethod()
      }
    },
    /***** 付款確認  End *****/
    async tryToPayOrder(paymentMethod, data) {
      try {
        await this.setInvoiceInfo(cloneDeep(this.submitData), 'prepaid-detail')
        const { params, ...other } = data
        this.tryingPayOrder = true
        await this.$store.dispatch('prepaid/storeOrder', {
          ...other,
          paymentMethod,
          status: 1,
          basePrice: this.basePrice,
          total: this.submitPriceTotal,
          ...this.invoiceStoreData,
        })
        this.$message({
          type: 'success',
          message: '編輯成功！',
        })
        this.updateOrder()
        this.paidDialogVisible = false
      } finally {
        this.tryingPayOrder = false
      }
    },
    async tryToStoreOrderItem() {
      const isNegative = this.submitPriceTotal < 0

      if (isNegative) {
        this.$confirm('訂單金額不能小於0', '提醒', {
          confirmButtonText: '確定',
          showCancelButton: false,
          type: 'warning',
          center: true,
        })
        return
      }

      const adds = this.currentOrder.params.filter(({ id }) => id === undefined)
      const data = {
        adds,
        orderId: this.currentOrder.orderNo,
        deleteIds: this.deleteIds,
        total: this.submitPriceTotal,
      }

      this.tryingStoreOrderItem = true
      try {
        await this.$store.dispatch('order/storeOrderItem', data)
        this.$message({
          type: 'success',
          message: '編輯成功！',
        })
        this.deleteIds = []
        this.updateOrder()
        this.cancelToTalEdit()
      } finally {
        this.tryingStoreOrderItem = false
      }
    },
    async tryToSaveOrder() {
      const { params, priceBase, priceTotal, ...other } = this.currentOrder
      let storeData = {
        ...other,
        merchantNote: '',
        basePrice: priceBase,
        total: priceTotal,
      }

      if (this.currentOrder.paymentMethod === 'Deposit') storeData.paymentStatus = 'PAID'

      this.tryingStore = true
      try {
        await this.$store.dispatch('prepaid/storeOrder', storeData)
        this.handleSaveSuccess()
        await this.updateOrder()
        this.editPaymentMethodShow = false
      } catch (error) {
        this.$message({
          type: 'error',
          message: `Server Error`,
        })
      } finally {
        this.tryingStore = false
      }
    },
    handleSaveSuccess() {
      this.$message({
        message: '編輯成功！',
        type: 'success',
      })
    },
    async updateOrder() {
      const updatedValue = await this.$store.dispatch('prepaid/fetchOrderSingle', this.defaultValue.id)
      this.$emit('update:defaultValue', updatedValue)
      this.submitData = cloneDeep(updatedValue)
      this.$emit('update')
    },
    updateBasePrice(isChildrenOrder = false) {
      let basePrice = this.prepaidPlanTotal
      basePrice = calcBasePrice({ price: basePrice, totalEditList: this.currentOrder.params })
      this.basePrice = basePrice
    },
    async tryToStorePayment() {
      if (this.currentOrder.paymentMethod === 'Deposit') {
        if (this.prepaidPlanItem.canPayByDeposit === false) {
          await this.$confirm(`此方案未設定可使用儲值點數抵扣，請問是否確定抵扣 ${this.currentOrder.priceTotal} 點？`, '抵扣未開放', {
            confirmButtonText: '確定',
            // showCancelButton: false,
            type: 'warning',
            center: true,
          })
        } else {
          await this.$confirm(`確定要使用儲值金抵扣 ${this.currentOrder.priceTotal} 點？`, '提醒', {
            confirmButtonText: '確定',
            // showCancelButton: false,
            type: 'warning',
            center: true,
          })
        }
        if (this.depositReduce < this.currentOrder.priceTotal) {
          await this.$confirm(`儲值金餘額不足，是否加值`, '提醒', {
            confirmButtonText: '確定',
            // showCancelButton: false,
            type: 'warning',
            center: true,
          })
          this.createDepositOrderVisible = true
          return
        }
      }

      this.tryToSaveOrder()
    },

    /************ 編輯客戶資訊相關 start ************/
    closeEditMemberForm() {
      this.editDetailEnabled = false
    },
    async tryToFetchDetail(memberId) {
      this.tryingGetMember = true
      this.memberInfo = await this.$store.dispatch('member/fetchSingle', { memberId })
      this.closeEditMemberForm()
      this.tryingGetMember = false
    },
    /************ 編輯客戶資訊相關 end ************/

    /************ 客戶資訊相關 start ************/
    closeMemberInfo() {
      this.memberInfoShow = false
    },
    /************ 客戶資訊相關 end ************/

    /************ 變更付款方式相關 start ************/
    onUpdatePayment(data) {
      const { allowExpired, paymentMethod, Card4No, PayerAccount5Code, bankType } = data
      this.currentOrder = {
        ...this.currentOrder,
        allowExpired,
        paymentMethod,
        Card4No,
        PayerAccount5Code,
        bankType,
        installments: data.installments?.length ? data.installments : [],
      }
      this.tryToStorePayment()
    },
    closeEditPaymentMethod() {
      this.editPaymentMethodShow = false
    },
    /************ 變更付款方式相關 end ************/

    /************ 變價相關 start ************/
    onSubmitTotalEdit(item) {
      this.currentOrder.params.push({ ...item })
    },
    clearParams() {
      this.currentOrder.params = this.currentOrder.params.filter(({ type }) => !['+', '-', '%'].includes(type))
    },
    onUpdateTotalStatement({ params, deleteIds }) {
      this.clearParams()
      this.currentOrder.params = [...this.currentOrder.params, ...params]
      this.deleteIds = [...deleteIds]
    },
    /************ 變價相關 end ************/

    closeDeductHistory() {
      this.visibleDeductHistory = false
    },
    openDeductHistory() {
      this.visibleDeductHistory = true
    },
    openOrderNoteEdit() {
      this.isOrderNoteEdit = true
    },
    cancelOrderNoteEdit() {
      this.isOrderNoteEdit = false
      this.currentOrder.note = this.defaultValue.note
    },
    updateOrderNoteEdit() {
      this.tryToSaveOrder()
      this.isOrderNoteEdit = false
    },
    openExpiredDateEdit() {
      this.isExpiredDateEdit = true
    },
    tryToStoreExpiredDateEdit() {
      const { expiredDate, extendedExpiredDate } = this.currentOrder
      const originalExpiredDate = this.originalExpiredDate || expiredDate
      if (extendedExpiredDate && new Date(extendedExpiredDate).getTime() < new Date(originalExpiredDate).getTime()) {
        this.$message.error('新的到期日不能早於原本的到期日')
        return
      }

      this.currentOrder.extendedExpiredDate = extendedExpiredDate ? `${formatDate(extendedExpiredDate, 'date-dash')} 23:59:59` : ''
      this.tryToSaveOrder()
      this.isExpiredDateEdit = false
    },
    cancelExpiredDateEdit() {
      this.isExpiredDateEdit = false
      // this.currentOrder.expiredDate = this.defaultValue.expiredDate
      this.currentOrder.extendedExpiredDate = this.defaultValue.extendedExpiredDate
    },
    goToPetInfoDetail(val) {
      this.closeAllInfo()
      if (val.alias === 'addService') {
        this.openCommentEdit()
      } else {
        this.petShow = true
        this.petInfoActiveTab = val.alias
        this.isShowPetList = val.isShowPetList
      }
    },
    goToMemberInfoDetail(val) {
      this.closeAllInfo()
      this.memberInfoShow = true
      this.memberInfoActiveTab = val
    },
  },
}
</script>
<template>
  <div v-loading="tryingGetMember" :class="$style.orderformSection">
    <div v-if="!totalAllShow" class="orderformSection__all">
      <div class="orderformSection__left">
        <div :id="orderHeaderId" :class="$style.header">
          <h5 class="Jost" :class="$style.title">{{ defaultValue.prepaidTitle }}</h5>
          <h5 class="mt-0">分店：{{ defaultValue.storeTitles.join(' | ') }}</h5>
          <div v-if="submitData.status === 1" class="inline-between">
            <h6 class="Jost d-flex align-items-center">
              <span>到期日：</span>
              <div v-if="!isExpiredDateEdit">
                <template v-if="currentOrder.extendedExpiredDate">
                  {{ currentOrder.extendedExpiredDate | formatDate }}
                </template>
                <template v-else-if="currentOrder.expiredDate">
                  {{ currentOrder.expiredDate | formatDate }}
                </template>
                <template v-else>
                  無使用期限
                </template>
              </div>
              <div v-else>
                <el-date-picker v-model="proxyExpiredDate" type="date" placeholder="請選擇日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd" class="isStyleExpiredDate"> </el-date-picker>
              </div>
            </h6>

            <div class="mb-1">
              <template v-if="!isExpiredDateEdit">
                <el-button class="is-round" size="mini" @click="openExpiredDateEdit">
                  <BaseIcon name="edit" />
                  <span>編輯</span>
                </el-button>
              </template>
              <template v-else>
                <el-button class="is-round" size="mini" @click="cancelExpiredDateEdit">
                  取消
                </el-button>
                <el-button class="is-round" type="primary" size="mini" @click="tryToStoreExpiredDateEdit">
                  儲存
                </el-button>
              </template>
            </div>
          </div>
          <div class="inline-between">
            <span>{{ defaultValue.created }} 成立訂單</span>
            <span>訂單來源：{{ defaultValue.source | orderSourceFilter }}</span>
          </div>
        </div>
        <div ref="leftCont" class="orderformSection__left__content" :style="`height:calc(100vh - ${headerHeight}px)`">
          <div style="min-height: 300px; padding-top: 20px" class="info-section">
            <!-- 客戶資訊 -->
            <BaseCollapse expanded is-order :order-theme="true" arrow-style="far">
              <template v-slot:title>
                <span>
                  <BaseIcon icon-style="fal" name="address-card" :class="[$style['header-icon-left'], 'fs-2xl', 'mr-3', 'align-text-bottom']" />
                  客戶資訊
                </span>
              </template>
              <OrderMemberInfo :member-info="memberInfo" @toDetail="goToMemberInfoDetail" />
            </BaseCollapse>
            <template>
              <BaseCollapse expanded is-order :order-theme="true" arrow-style="far">
                <template v-slot:title>
                  <span>
                    <BaseIcon v-if="$merchantI18n() === 'pet'" name="bone" :class="[$style['header-icon-left'], 'fs-lg', 'mr-3']" style="transform: rotate(-45deg)" />
                    {{ $t('reserve.CLIENT') }}{{ $t('reserve.PET_SIZE') }}
                  </span>
                </template>
                <div class="mb-3" :class="$style.titleBox">{{ defaultValue.categoryTitle }} | {{ defaultValue.sizeTitle }}</div>
              </BaseCollapse>
            </template>
            <!-- 發票資訊 -->
            <template v-if="false && defaultValue.status === 1 && defaultValue.invoice.InvoiceNumber">
              <BaseCollapse v-if="false" is-order :order-theme="true" arrow-style="far">
                <template v-slot:title>
                  <span> 發票資訊</span>
                </template>
                <div style="margin-bottom:30px">
                  <div :class="$style.invoice">
                    <div style="margin-bottom:10px" :class="$style['invoice__title']"> 訂單 #{{ defaultValue.orderNo }} </div>
                    <div class="info">
                      <el-row :gutter="20">
                        <el-col :span="12" :xs="24">
                          <div class="info-item">
                            <span class="title">發票日期：</span>
                            <span>{{ defaultValue.invoice.CreateTime | formatDate }}</span>
                          </div>
                          <div class="info-item">
                            <span class="title">發票號碼：</span>
                            <span>{{ defaultValue.invoice.InvoiceNumber }}</span>
                          </div>
                          <div class="info-item">
                            <span class="title">隨機碼：</span>
                            <span>{{ defaultValue.invoice.RandomNum }}</span>
                          </div>
                        </el-col>
                        <el-col :span="12" :xs="24">
                          <div class="info-item">
                            <span class="title">發票形式：</span>
                            <span>{{ taxTypeMap[defaultValue.invoice.taxType] }}</span>
                          </div>
                          <div v-if="defaultValue.invoice.taxType === 'B2C'" class="info-item">
                            <span class="title">載具類別：</span>
                            <span>{{ carrierTypeMap[defaultValue.invoice.CarrierType] }}</span>
                          </div>
                          <div v-if="defaultValue.invoice.taxType === 'B2C' && ['0', '1'].includes(defaultValue.invoice.CarrierType)" :span="12" :xs="24" class="info-item">
                            <span class="title">載具編號：</span>
                            <span>{{ defaultValue.invoice.CarrierNum }}</span>
                          </div>
                          <div v-if="defaultValue.invoice.taxType === 'B2B'" class="info-item">
                            <span class="title">統一編號</span>
                            <span>{{ defaultValue.invoice.taxId }}</span>
                          </div>
                          <div v-if="defaultValue.invoice.taxType === 'DONATE'" class="info-item">
                            <span class="title">捐贈碼</span>
                            <span>{{ defaultValue.invoice.LoveCode }}</span>
                          </div>
                        </el-col>
                      </el-row>
                    </div>
                  </div>
                </div>
              </BaseCollapse>
            </template>
            <!-- 訂單備註 -->
            <BaseCollapse expanded is-order :order-theme="true" arrow-style="far">
              <template v-slot:title>
                <span>
                  <BaseIcon v-if="$merchantI18n() === 'pet'" icon-style="fal" name="piggy-bank" :class="[$style['header-icon-left'], 'fs-lg', 'mr-3']" />
                  選擇{{ $t('prepaid.BASE') }}方案
                </span>
              </template>
              <div>
                <span class="fs-medium text-secondary">{{ $t('prepaid.BASE') }}方案</span>
                <div class="mt-3">{{ defaultValue.prepaidTitle }}</div>
              </div>
              <el-divider class="my-4"></el-divider>
              <div class="note">
                <div class="inline-between align-items-center">
                  <span style="font-weight: 500">備註</span>
                  <el-button v-if="!isOrderNoteEdit" type="text" class="py-0 h-auto" @click="openOrderNoteEdit">
                    <BaseIcon name="edit" class="text-primary" />
                    編輯備註
                  </el-button>
                  <div v-else>
                    <el-button size="mini" class="is-round" @click="cancelOrderNoteEdit"> 取消 </el-button>
                    <el-button size="mini" class="is-round" type="primary" @click="updateOrderNoteEdit"> 儲存 </el-button>
                  </div>
                </div>
                <div class="mt-3 text-secondary">
                  <div v-if="!isOrderNoteEdit">
                    <template v-if="currentOrder.note">
                      {{ currentOrder.note }}
                    </template>
                    <div v-else style="opacity: 0.5">
                      目前尚無備註
                    </div>
                  </div>
                  <el-input v-else v-model="currentOrder.note" type="textarea" :rows="5" placeholder="请输入備註內容" class="is-border is-round bg-white"> </el-input>
                </div>
              </div>
            </BaseCollapse>
            <template>
              <ProfitSharing order-type="prepaid" :order-info="defaultValue" @updateOrder="updateOrder" />
            </template>
          </div>
        </div>
      </div>
      <div class="orderformSection__right">
        <template>
          <!-- 客戶編輯 -->
          <template v-if="editDetailEnabled">
            <MemberForm :default-value="memberInfo" @update="tryToFetchDetail" @close="closeEditMemberForm" />
          </template>
          <!-- 客戶資訊 -->
          <template v-if="memberInfoShow && !editDetailEnabled">
            <MemberInfo :member-info="memberInfo" :member-info-active-tab="memberInfoActiveTab" @update="tryToFetchDetail" @close="closeMemberInfo" />
          </template>
          <!-- 寵物選擇 -->
          <template v-if="petShow">
            <PetList
              ref="petList"
              :default-value="defaultValue"
              :active-id="defaultValue.pet.id"
              :member-info="memberInfo"
              :pet-info-active-tab="petInfoActiveTab"
              :is-show-pet-list="isShowPetList"
              @close="closePet"
              @update="tryToFetchDetail(memberInfo.id)"
            />
          </template>
          <!-- 查看歷史紀錄 -->
          <template v-if="orderHistoryShow">
            <div class="orderformSection__right__header">
              <button class="el-drawer__close-btn" aria-label="close drawer" type="button" @click="closeHistory"><i class="el-dialog__close el-icon el-icon-close"></i></button>
              <h4 class="orderformSection__right__title">訂單變更記錄</h4>
            </div>
            <div class="orderformSection__right__content">
              <el-timeline>
                <el-timeline-item v-for="log in currentHistory" :key="log.id" :timestamp="log.created | formatDate('dateTime')" type="primary" placement="top">
                  {{ log.description }}
                  <span style="font-size: 13px">
                    <span v-if="log.creator">- {{ log.creator }}</span>
                  </span>
                  <div v-if="log.note">{{ log.note }}</div>
                </el-timeline-item>
              </el-timeline>
            </div>
          </template>
          <!-- 編輯付款方式 -->
          <template v-if="editPaymentMethodShow">
            <PaymentEditForm :current-order="currentOrder" :loading="tryingStore" @update="onUpdatePayment" @close="closeEditPaymentMethod" />
          </template>
          <!-- 客戶使用歷程 -->
          <template v-if="visibleDeductHistory">
            <DeductHistory :default-value="defaultValue" @close="closeDeductHistory" />
          </template>
        </template>
        <!-- 變價 -->
        <div :class="$style.total">
          <div class="total__cont">
            <TotalStatementDetail
              order-type="prepaid"
              :default-value="submitData"
              :member-info="memberInfo"
              @editOpenTotalEdit="editOpenTotalEdit"
              @editOpenPaymentMethod="editOpenPaymentMethod"
              @editOpenHistory="editOpenHistory"
              @tryToCancelOrder="tryToCancelOrder"
              @editOpenRefund="editOpenRefund"
              @openDeductHistory="openDeductHistory"
            >
            </TotalStatementDetail>
          </div>
        </div>
      </div>

      <!-- 底部按鈕 -->
      <div class="orderformSection__bottom">
        <div style="display: flex; align-items: center">
          <BaseStateLabel class="is-border" :state="defaultValue.status | orderStatusFilter('color')">{{ defaultValue.status | orderStatusFilter('text') }}</BaseStateLabel>
          <div style="padding-left: 20px" class="text-secondary fw-medium Jost">
            NT${{ getPaidAmount }}
            <span v-if="defaultValue.status === 2" style="color:#e35d5d;margin-left:5px;font-size:12px;display:inline-block">
              ( {{ defaultValue.paymentMethod === 'Installment' ? getInstallmentUnpayCount : '' }}未付款金額 NT${{ defaultValue.priceTotal - getPaidAmount }} )</span
            >
            <br />
            <BaseStateLabel v-if="defaultValue.paymentMethod === 'Installment'" class="text-muted-0" style="padding-top: 5px" state="info" text
              >{{ defaultValue.installments.length }}期付款</BaseStateLabel
            >
            <BaseStateLabel v-else class="text-muted-0" style="padding-top: 5px" state="info" text>{{ defaultValue.paymentMethod | orderPaymentMethodFilter }}</BaseStateLabel>
          </div>
        </div>

        <div style="flex-shrink:0;padding:0 10px; margin-left: auto;">
          <el-button v-if="defaultValue.status !== 5 && defaultValue.status !== 0" class="no-color-text-btn is-circle is-border" style="font-size: 20px" @click="showShareDialog">
            <BaseIcon name="paper-plane" :icon-style="'fal'"></BaseIcon>
          </el-button>
          <el-button style="font-size: 20px" class="no-color-text-btn is-circle is-border" :disabled="defaultValue.prepaidGroupOrdering === 0" @click="copyThisPrepaidOrder">
            <BaseIcon name="copy" :icon-style="'fal'"></BaseIcon>
          </el-button>
          <!-- 分享連結 -->
          <el-dialog title="選擇發送方式" :visible.sync="shareDialogVisible" top="0" width="680px" append-to-body lock-scroll @open="tryToGetShareLink">
            <ul class="p-3 mb-3" style="border-radius: 8px; background: $color-line">
              <li class="text-primary mb-3">{{ `#${defaultValue.orderNo}` }}</li>
              <li class="mb-3">使用人：{{ defaultValue.fullName }} {{ defaultValue.gender | genderFilter }}</li>
              <li>訂購內容：{{ defaultValue.prepaidTitle }}</li>
            </ul>
            <div :class="$style['share__buttons']">
              <div :class="$style['share__button']">
                <el-button type="text" class="isPrimary" :class="$style['share__button']" @click="handleShareLink('facebook')">
                  <i class="fab fa-facebook-square" :class="$style['share__icon']"></i>
                </el-button>
                <div :class="$style['share__label']">Facebook</div>
              </div>
              <div :class="$style['share__button']">
                <el-button type="text" class="isPrimary" :class="$style['share__button']" @click="handleShareLink('line')">
                  <BaseIcon :class="$style['share__icon']" name="line" icon-style="fab" />
                </el-button>
                <div :class="$style['share__label']">Line</div>
              </div>
              <div :class="$style['share__button']" :loading="tryingSendSMS">
                <el-button type="text" class="isPrimary" :class="$style['share__button']" @click="tryToSendSMS">
                  <i class="fas fa-sms" :class="$style['share__icon']"></i>
                </el-button>
                <div :class="$style['share__label']">簡訊</div>
              </div>
              <div :class="$style['share__button']">
                <el-button type="text" class="isPrimary" :class="$style['share__button']" @click="copyShareLink">
                  <i class="fas fa-copy" :class="$style['share__icon']"></i>
                </el-button>
                <div :class="$style['share__label']">複製連結</div>
              </div>
            </div>
          </el-dialog>
        </div>

        <div style="flex-shrink:0" class="ml-3">
          <el-button
            v-if="defaultValue.status === 2 && defaultValue.paymentMethod !== 'Credit' && defaultValue.paymentMethod !== 'Vacc'"
            class="is-round orderformSection__bottom__btn-item"
            type="success"
            :loading="tryingPayOrder"
            @click="openPaidDialog"
            >{{ defaultValue.paymentMethod === 'Installment' ? '分期' : '' }}付款</el-button
          >
        </div>
      </div>
    </div>

    <!-- 變價或加購 -->
    <div v-if="totalAllShow" class="orderformSection__all">
      <div class="orderformSection__right" style="border-right: #dcdfe6 1px solid">
        <div class="orderformSection__right__header">
          <button class="el-drawer__close-btn" aria-label="close drawer" type="button" @click="cancelToTalEdit"><i class="el-dialog__close el-icon el-icon-close"></i></button>
          <h4 class="orderformSection__right__title">
            <div class="inline-between" style="padding-right: 15px; align-items: center">
              <span> 價格編輯 </span>
            </div>
          </h4>
        </div>

        <div class="orderformSection__right__content" style="padding: 0 0 20px 0">
          <TotalStatement enabled-edit is-order-created :member-info="memberInfo" order-type="prepaid" :default-value="currentOrder" @openTotalEdit="openTotalEdit" @update="onUpdateTotalStatement">
            <div :class="$style.bottom" style="padding: 0 0 26px;">
              <div class="btn-group-inline">
                <el-button class="is-round" type="primary" :loading="tryingStoreOrderItem" @click="tryToStoreOrderItem">儲存</el-button>
              </div>
            </div>
          </TotalStatement>
        </div>
      </div>
      <div class="orderformSection__left" style="border: 0">
        <div class="orderformSection__left__content" style="padding-bottom: 0">
          <TotalEdit @submit="onSubmitTotalEdit" />
        </div>
      </div>
    </div>
    <!-- 退款 -->
    <el-dialog title="退款" width="550px" :visible.sync="orderRefundShow" top="0" append-to-body destroy-on-close>
      <RefundForm :current-order="currentOrder" :loading="tryingRefund" @submit="tryToRefund" @close="closeOpenRefund" />
    </el-dialog>
    <OrderChangeStatusDialog :container-all-item="{}" :visible.sync="statusDialogVisible" :order="{ ...currentOrder, status: 0 }" @cancelled="updateOrder" />

    <!-- 付款確認 -->
    <DialogPaidConfirm v-model="paidConfirmValue" :visible.sync="isDialogPaidConfirmVisible" type="prepaid" @submit="paidConfirm" />

    <!-- 簽名請款 -->
    <SignatureDialog
      :one-step="true"
      :start-tab="1"
      :member-info="memberInfo"
      :props-store-invoice-setting="1"
      :visible.sync="signDialogVisible"
      :order="{ ...submitData }"
      @closeSignature="closeSignature"
      @closeSignaturDialog="closeSignaturDialog"
    />

    <!-- 新增儲值金訂單 -->
    <el-drawer
      ref="depositOrderForm"
      class="only-close"
      :class="{ appStyle: appStyle }"
      :visible.sync="createDepositOrderVisible"
      :append-to-body="true"
      :size="$root.isSmallDevice ? '100%' : '90%'"
      destroy-on-close
      :modal-append-to-body="false"
      :wrapper-closable="false"
      custom-class="order-drawer"
    >
      <DepositOrderForm :order-member-id="memberInfo.id" order-type="deposit" @store="onCreateDepositOrderDone" />
    </el-drawer>

    <el-drawer
      ref="prepaidCopyDrawer"
      class="only-close"
      :class="{ appStyle: appStyle }"
      :visible.sync="drawerPrepaidOrderFormVisible"
      append-to-body
      :size="$root.isSmallDevice ? '100%' : '90%'"
      destroy-on-close
      :modal-append-to-body="false"
      :wrapper-closable="false"
      custom-class="order-drawer"
    >
      <PrepaidOrderForm order-type="prepaid" advance-order-type="copy" :prepaid-group.sync="defaultValue" @store="handleUpdateOrders" />
    </el-drawer>

    <!-- 分期付款彈窗 -->
    <PaymentFormDialog
      :visible.sync="installmentDialogVisible"
      :payment-way="'installments'"
      :handle-dialog-status="'orderPagePayment'"
      :installment-order="installmentOrder"
      :price-total="installmentOrder.priceTotal"
      @close="handleUpdateOrders"
    ></PaymentFormDialog>
  </div>
</template>
<style lang="scss" module>

.orderformSection {
  :global {
    .form-block-title {
      font-size: 16px;
      padding-bottom: 0;
      margin-top: 0;
    }

    .el-form-item {
      // margin-bottom: 10px;
    }

    .el-tabs__active-bar {
      background-color: $color-primary !important;
    }

    .info-section {
      padding: 30px 40px;

      @include max-lg {
        padding: 15px 20px;
      }
    }

    .orderformSection {
      &__all {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        height: 100%;
        // display: none;
      }

      &__left {
        width: 57%;
        border-right: $color-border-base 1px solid;
        display: flex;
        flex-direction: column;
        justify-content: stretch;
        background: $color-line;

        &__content {
          height: 100vh;
          overflow: auto;

          padding-bottom: 90px;
        }

        .note {
          background: $color-line;
          padding: 1.25rem;
        }
      }

      &__right {
        position: relative;
        width: 43%;
        height: calc(100vh);
        overflow: hidden;
        background: $color-line;

        .orderformSection__right__header {
          background-color: $color-line;
          z-index: 999;
        }

        &__title {
          margin: 0;
          padding: 19px 0;
          padding-left: 50px;
        }

        &__header {
          position: relative;
          border-bottom: $color-border-base 1px solid;

          .el-drawer__close-btn {
            // font-weight: 300;
            color: #72767b;
            position: absolute;
            padding: 15px;
            border: 0;
            left: 0;
            top: 3px;
          }

          .el-tabs__item {
            height: auto;
            padding: 10px 0;
          }

          .el-tabs__nav-wrap::after {
            display: none;
          }

          .el-tabs__header {
            margin-bottom: 0;
          }

          .el-tabs--top {
            margin-left: 60px;

            @include max-lg {
              margin-left: 30px;
            }
          }
        }

        &__content {
          z-index: 10;
          height: calc(100vh - 60px);
          overflow: auto;
          padding: 30px;
          padding-bottom: 120px;
          position: relative;
          background-color: $color-line;

          @include max-lg {
            padding: 20px;
          }
        }
      }

      &__bottom {
        position: absolute;
        width: 100%;
        bottom: 0;
        left: 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 20px 30px;
        background: #fff;
        box-shadow: 0 -5px 5px rgba(#eee, 0.3);
        z-index: 999;

        @include touch {
          position: static;
          // position: fixed;
        }

        &__btn {
          width: 40%;
        }

        &__btn-item {
          // min-width: 132px;
          width: 360px;
          max-width: 100%;

          @include max-lg {
            width: 100%;
          }
        }
      }
    }
  }
}

.header {
  margin-top: 5px;
  // margin-bottom: 30px;
  padding-right: 40px;
  padding-left: 60px;
  padding-bottom: 10px;
  border-bottom: $color-border-base 1px solid;

  @include max-lg {
    padding-right: 20px;
  }

  :global {
    h5 {
      font-size: 18px;
    }
  }
}

.title:not(:first-child) {
  margin-top: 30px;
}

.infoList {
  // margin-bottom: 30px;
  padding-top: 5px;

  // border-bottom: 1px solid $color-border-base;
  // font-size: 16px;
  :global {
    .muted {
      color: $color-text-secondary;
    }

    .el-tag + .el-tag {
      margin-left: 10px;
    }

    .infoList {
      &__title {
        font-weight: 500;
        margin-bottom: 20px;
      }

      &__item {
        margin-bottom: 15px;
      }

      &__row {
        margin-bottom: 20px;
      }
    }
  }
}

.total {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  height: 100%;
  z-index: 1;

  @include touch {
    position: static;
  }

  :global {
    .total {
      &__cont {
        // padding: 30px 30px;
        height: calc(100% - 80px);

        @include touch {
          height: auto;
        }
      }

      &__bottom {
        position: absolute;
        width: 100%;
        bottom: 0;
        left: 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 20px 30px;
        background: #fff;
        box-shadow: 0 -5px 5px rgba(#eee, 0.3);
        z-index: 999;

        @include touch {
          // position: static;
          position: sticky;
          flex-wrap: wrap;
          padding: 15px;
          justify-content: flex-start;
        }

        &__left {
          @include touch {
            width: 100%;
          }
        }

        &__btn {
          width: 40%;
        }

        &__btn-item {
          // min-width: 132px;
          width: 360px;
          max-width: 100%;

          @include max-lg {
            width: 100%;
          }
        }

        &__right {
          display: flex;
          align-items: center;
          margin-left: 1rem;

          &__alert {
            display: inline-block;
            width: auto;
            margin-left: 20px;
            flex-shrink: 0;

            @include touch {
              width: 100%;
              margin-left: 0;
              margin-top: 1rem;
            }
          }

          @include touch {
            display: block;
            width: 100%;
            margin-left: 0;
            order: -1;
            margin-bottom: 10px;
          }
        }
      }
    }
  }
}

.bottom {
  /* position: absolute;
  bottom: 0; */
  width: 100%;
  padding: 0 30px 0;

  @include touch {
    position: static;
  }
}

.invoice {
  &__title {
    color: $color-secondary;
  }

  :global {
    .order-id {
      font-size: 16px;
      letter-spacing: 1.6px;
      line-height: 18px;
      margin-bottom: 20px;
      font-weight: 500;
    }

    .info {
      background: white;

      @include touch {
        border: 1px solid #c6c6ba;
      }

      .el-col {
        padding-top: 7.5px;
        padding-bottom: 7.5px;
      }

      .info-item {
        .title {
          width: 85px;
          display: inline-block;
          color: #919191;

          & + span {
            color: $color-secondary;
          }
        }

        & + .info-item {
          margin-top: 15px;
        }
      }
    }
  }

  & + .invoice {
    margin-top: 40px;
  }
}

.titleBox {
  padding: 20px;
  background: #fff;
}

.share {
  &__buttons {
    display: flex;
    align-items: center;
    text-align: center;
  }

  &__button {
    flex: 1;
  }

  &__icon {
    font-size: 3rem;
  }

  &__label {
    margin-top: 10px;
  }
}
</style>
